"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderItemStatus = exports.OrderStatus = exports.OrderDocumentType = exports.OrderDocumentICountDocumentStatus = void 0;
var api_service_1 = require("./api-service");
var OrderService = /** @class */ (function (_super) {
    __extends(OrderService, _super);
    function OrderService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'orders';
        return _this;
    }
    OrderService.prototype.orders = function (params) {
        return this.getCollectionRequest(this.url('orders'), { params: params });
    };
    OrderService.prototype.getOrder = function (orderNumber) {
        return this.getRequest(this.url('orders', orderNumber));
    };
    OrderService.prototype.deleteOrder = function (orderNumber) {
        return this.deleteRequest(this.url('orders', orderNumber));
    };
    OrderService.prototype.getOrderComments = function (orderNumber) {
        return this.getRequest(this.url('orders', orderNumber, 'comments'));
    };
    OrderService.prototype.addOrderComment = function (orderNumber, comment) {
        return this.postRequest(this.url('orders', orderNumber, 'comments'), comment);
    };
    OrderService.prototype.updateOrderComment = function (orderNumber, commentNumber, comment) {
        return this.putRequest(this.url('orders', orderNumber, 'comments', commentNumber), comment);
    };
    OrderService.prototype.getOrderDocuments = function (orderNumber) {
        return this.getRequest(this.url('orders', orderNumber, 'documents'));
    };
    OrderService.prototype.getOrderDocument = function (orderNumber, documentId) {
        return this.postRequest(this.url('orders', orderNumber, 'documents', documentId), undefined, {
            responseType: 'blob',
        });
    };
    OrderService.prototype.holdOrder = function (orderNumber, data) {
        return this.postRequest(this.url('orders', orderNumber, 'hold_reasons'), data);
    };
    OrderService.prototype.getOrderGuards = function (orderNumber) {
        return this.patchRequest(this.url('orders', orderNumber, 'guards'), undefined);
    };
    OrderService.prototype.getOrderGuard = function (orderNumber, guard) {
        return this.patchRequest(this.url('orders', orderNumber, 'guards', guard || ''), undefined);
    };
    OrderService.prototype.actionOrder = function (orderNumber, action, data) {
        return this.patchRequest(this.url('orders', orderNumber, 'actions', action), data);
    };
    OrderService.prototype.transitOrderState = function (orderNumber, transition) {
        return this.patchRequest(this.url('orders', orderNumber, 'transition', transition), undefined);
    };
    OrderService.prototype.getOrderHoldReasons = function (orderNumber) {
        return this.getRequest(this.url('orders', orderNumber, 'hold_reasons'));
    };
    OrderService.prototype.resolveOrderReasons = function (orderNumber) {
        return this.patchRequest(this.url('orders', orderNumber, 'hold_reasons', 'resolve'), undefined);
    };
    OrderService.prototype.getOrderItems = function (orderNumber) {
        return this.getRequest(this.url('orders', orderNumber, 'items'));
    };
    OrderService.prototype.billOrder = function (orderNumber, data) {
        return this.patchRequest(this.url('orders', orderNumber, 'bill'), data);
    };
    OrderService.prototype.refundOrderItems = function (orderNumber, data) {
        return this.patchRequest(this.url('orders', orderNumber, 'refund'), data);
    };
    OrderService.prototype.createShipment = function (orderNumber, data) {
        return this.postRequest(this.url('orders', orderNumber, 'shipments'), data);
    };
    OrderService.prototype.updateShipment = function (orderNumber, shipmentId, data) {
        return this.patchRequest(this.url('orders', orderNumber, 'shipments', shipmentId), data);
    };
    OrderService.prototype.getOrderShipments = function (orderNumber) {
        return this.getRequest(this.url('orders', orderNumber, 'shipments'));
    };
    OrderService.prototype.getOrderPaymentMethods = function (orderNumber) {
        return this.getRequest(this.url('orders', orderNumber, 'payments'));
    };
    OrderService.prototype.voidOrder = function (orderNumber, data) {
        return this.patchRequest(this.url('orders', orderNumber, 'void'), data);
    };
    OrderService.prototype.icountResend = function (orderNumber, data) {
        return this.postRequest(this.url('orders', orderNumber, 'icount', 'resend'), data);
    };
    OrderService.prototype.report = function (params) {
        return this.getCollectionRequest(this.url('report'), { params: params });
    };
    OrderService.prototype.reportGrouped = function (params) {
        return this.getCollectionRequest(this.url('report'), { params: params });
    };
    OrderService.prototype.reportItems = function (params) {
        return this.getCollectionRequest(this.url('report', 'items'), { params: params });
    };
    OrderService.prototype.reportItemsGrouped = function (params) {
        return this.getCollectionRequest(this.url('report', 'items'), { params: params });
    };
    OrderService.prototype.exportReport = function (params) {
        return this.getRequest(this.url('report', 'export'), { params: params });
    };
    OrderService.prototype.exportReportItems = function (params) {
        return this.getRequest(this.url('report', 'items', 'export'), { params: params });
    };
    return OrderService;
}(api_service_1.ApiService));
exports.default = OrderService;
var OrderDocumentICountDocumentStatus;
(function (OrderDocumentICountDocumentStatus) {
    OrderDocumentICountDocumentStatus["ERROR"] = "error";
    OrderDocumentICountDocumentStatus["SUCCESS"] = "success";
    OrderDocumentICountDocumentStatus["WARNING"] = "warning";
})(OrderDocumentICountDocumentStatus = exports.OrderDocumentICountDocumentStatus || (exports.OrderDocumentICountDocumentStatus = {}));
var OrderDocumentType;
(function (OrderDocumentType) {
    OrderDocumentType["CREDIT_MEMO"] = "credit_memo";
    OrderDocumentType["INVOICE"] = "invoice";
    OrderDocumentType["RECEIPT"] = "receipt";
})(OrderDocumentType = exports.OrderDocumentType || (exports.OrderDocumentType = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["APPROVED"] = "approved";
    OrderStatus["CANCELED"] = "canceled";
    OrderStatus["COMPLETED"] = "completed";
    OrderStatus["ON_HOLD"] = "on_hold";
    OrderStatus["PLACED"] = "placed";
    OrderStatus["PROCESSING"] = "processing";
    OrderStatus["REFUNDED"] = "refunded";
    OrderStatus["SHIPPED"] = "shipped";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderItemStatus;
(function (OrderItemStatus) {
    OrderItemStatus["PARTIALLY_SHIPPED"] = "partially_shipped";
    OrderItemStatus["PROCESSING"] = "processing";
    OrderItemStatus["SHIPPED"] = "shipped";
})(OrderItemStatus = exports.OrderItemStatus || (exports.OrderItemStatus = {}));
//# sourceMappingURL=order-service.js.map